export default __webpack_public_path__ + "static/media/otto.4eab8f9e.png";